<template>
  <div class="w-full h-full">
    <div class="showOnMobile w-full h-full md:hidden">
      <slot name="mobile"></slot>
    </div>
    <div class="showOnDesktop  w-full h-full hidden md:block">
      <slot name="desktop"></slot>
    </div>
  </div>
</template>
